
// import Beauty from'../../../assets/Icons/Beauty.png'
import Beauty from '../../../src/New_Website_V2/Assets/Beauty.png'
// import Hair from'../../../assets/Icons/Hair.png'
// import NailCare from'../../../assets/Icons/NailCare.png'
// import Cleaning from'../../../assets/Icons/cleaningCatIcon.png'
// import Auto from'../../../assets/Icons/Auto.png'
// import Repair from'../../../assets/Icons/repair.png'
// import Electric from'../../../assets/Icons/electric.png'
// import GarmentIcon from'../../../assets/Icons/garmentIcon.png'
// import DomesticIcon from'../../../assets/Icons/domesticHelp.png'
// import GardenIcon from'../../../assets/Icons/gardenCare.png'
// import TutoringIcon from'../../../assets/Icons/tutoring.png'
// import HealthIcon from'../../../assets/Icons/healthFit.png'
// import AstroIcon from'../../../assets/Icons/astro1.png'
// import ProServicesIcon from'../../../assets/Icons/proServices.png'
// import BodyCareIcon from'../../../assets/Icons/BodyCareIcon.png'
// import petCarIcon from'../../../assets/Icons/petCarIcon.png'

// import ExtraIcon from'../../../assets/Icons/extraicon.png'

export const catImages={
    // 'Home Care':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1692874711760-lg.png',
    // 'Hair Care':Hair,
    // 'Auto Care':Auto,
    // 'Pet Care':petCarIcon,
    // 'Garment Care':GarmentIcon,
    'Beauty':Beauty,
    // 'Tutoring':TutoringIcon,
    // 'Body Care':BodyCareIcon,
    // 'Professional Services':ProServicesIcon,
    // 'Astro & More':AstroIcon,
    // 'Nail Care':NailCare,
    // 'Health & Fitness':HealthIcon,
    // 'Cleaning':Cleaning,
    // 'Electrical':Electric,
    // 'Domestic Help':DomesticIcon,
    // 'Extra Services':ExtraIcon,
    // 'Garden Care':GardenIcon,
    // 'Appliance Services':Repair
}

export const subcatImages={
    'Beard Grooming':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1763714474583-lg.webp',
    'Waxing & Threading':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753179028111-lg.webp',
    'Hair Colour':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1763714470032-lg.webp',
    'Hair Cut & Style':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1763714471332-lg.webp',
    'Beauty Treatments':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1763714472633-lg.webp',
    'Haircut & beard styling':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1766052287725-lg.webp',

    'Manicure': 'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1763715309725-lg.webp',
    'Pedicure': 'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1763715310393-lg.webp',
    'Nail Styling': 'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1763715311042-lg.webp',
    'Beauty Treatments':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1763714473932-lg.webp',
    'Clean Ups':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1763714469374-lg.webp',
    'Facial': 'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1763714473281-lg.webp',
    'Makeup': 'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753181724268-lg.webp',
    'Bleach/De-Tan':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1763714471985-lg.webp',
    'Bike Wash':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753422724864-lg.webp',
    'Car Wash':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753422727143-lg.webp',
    'Bike Repair':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753422730219-lg.webp',
    'Car Repair':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753422729119-lg.webp',
    'Car Body Shop':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753422728240-lg.webp',
    'Maintenance & Repair':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753422729119-lg.webp',
    'Interior & Detailing':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753422726062-lg.webp',
    'Refridgerator':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1763712903326-lg.webp',
    'Geyser':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1763712905929-lg.webp',
    'Washing Machine':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1763710973711-lg.webp',
    'Air Conditioner':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1763712903970-lg.webp',
    'Air Cooler':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1763712904619-lg.webp',
    'Television':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1763712906574-lg.webp',
    'Inverter/Stabilizer':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1763712905273-lg.webp',
    'Water Purifier':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1763712901991-lg.webp',
    'Kitchen Cleaning':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1763713911729-lg.webp',

    


    'Body Baths':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753770053184-lg.webp',
    'Body Scrub':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753770051443-lg.webp',
    'Body Wraps':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753770055798-lg.webp',
    'Body Treatment':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753770054057-lg.webp',
    'Massage':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753770055798-lg.webp',

    'Pet Grooming':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753770308512-lg.webp',
    'Dog Walking':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753770306742-lg.webp',
    'Pet Sitting':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753770306742-lg.webp',
    'Dog Training':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753770306742-lg.webp',
    'Pet Day-care & Boarding':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753770307626-lg.webp',

    'Alterations':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753770673268-lg.webp',
    'Dry Cleaning':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753770674983-lg.webp',
    'Laundary & Folding':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753770674134-lg.webp',
    'Laundry':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753770674983-lg.webp',
    'Tailoring':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753770673268-lg.webp',

    'Accu Treatment & More':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753771351737-lg.webp',
    'Physical Trainer':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753771360032-lg.webp',
    'Chiropractic':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753771383111-lg.webp',
    'Yoga':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753771354087-lg.webp',
    'Physical Therapy':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753771355341-lg.webp',
    'Nutritionist':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753771075729-lg.webp',

    'Architects':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753771072057-lg.webp',
    'Psychic Reading':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753771073783-lg.webp',
    'Vaastu':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753768990711-lg.webp',
    'Astrology':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753768992914-lg.webp',
    'Numerology':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753771077914-lg.webp',
    'Feng Shui':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753768991807-lg.webp',
    'Photography':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753771072926-lg.webp',
    'Lawn Care & Landscaping':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753771078998-lg.webp',

    'Kitchen & Dinning cleaning':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753779030611-lg.webp',
    'Bathroom cleaning':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753779033263-lg.webp',
    'House cleaning':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753779029757-lg.webp',
    'Furniture & Furnishing':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1763713784935-lg.webp',
    'Kitchen & Dinning cleaning':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753779032370-lg.webp',
    'Move In Move Out':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753779035206-lg.webp',
    'Junk Removal':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753779034115-lg.webp',
    'Baby Sitting':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753779855255-lg.webp',
    'Dish Washing':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753779857216-lg.webp',
    'Cook':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753779856366-lg.webp',
    'Maid':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753779030611-lg.webp',
    'Bathroom Cleaning':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1763713784284-lg.webp',

    'Switch & Socket':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753780000081-lg.webp',
    'Electrical Services':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753779996420-lg.webp',
    'Appliance Installation & Repair':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753779995544-lg.webp',
    'Fan':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753779997483-lg.webp',
    'Light':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1763710969156-lg.webp',
    'MCB & Fuse':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753779999195-lg.webp',

    'Plumbing':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753773788979-lg.webp',
    'Carpenter':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753773789841-lg.webp',
    'Limo':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753769339455-lg.webp',
    'Battery Service & Repair':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753769340560-lg.webp',
    'Suspension & Front-End Services':'https://slash-images.s3.us-west-2.amazonaws.com/Images_New/1753769341629-lg.webp',
    'Combo':'https://qf-test-media.s3.us-west-2.amazonaws.com/Images_New/1752733133413-lg.png'




















}